var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCameraTakePicture = function SvgCameraTakePicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M11 20.167a9.167 9.167 0 1 1 0-18.334 9.167 9.167 0 0 1 0 18.334Zm0-1.834a7.333 7.333 0 1 0 0-14.666 7.333 7.333 0 0 0 0 14.666ZM15.583 11a4.583 4.583 0 1 1-9.166 0 4.583 4.583 0 0 1 9.166 0Z"
  })));
};

export default SvgCameraTakePicture;